// src/pages/Home.js
import React from 'react';
import TerminosYCondiciones from '../PoliticaYTerminosComponents/TerminosYCondiciones';
function Home() {
  return (
    <div>
      <TerminosYCondiciones/>
    </div>
  );
}

export default Home;